import { Injectable } from '@angular/core';
import { ColumnDataTypes } from '@database/models';
import { ColumnModel, fileBooleanMappings } from '@shared';
import { EditStyleModel } from '../../models';

@Injectable({
	providedIn: 'root'
})
export class ColumnInformationService {
	public constructor() {}

	public isColumnRequired(columnModel: ColumnModel): boolean {
		return !fileBooleanMappings[columnModel.is_column_nullable];
	}

	public isColumnTypeNumeric(columnModel: ColumnModel): boolean {
		return columnModel.data_type === ColumnDataTypes.NUMERIC;
	}

	public isColumnTypeChar(columnModel: ColumnModel): boolean {
		return columnModel.data_type === ColumnDataTypes.CHAR;
	}

	public isColumnTypeTime(columnModel: ColumnModel): boolean {
		return (
			columnModel.edit_style &&
			(columnModel.edit_style.toLowerCase() === EditStyleModel.time24 ||
				columnModel.edit_style.toLowerCase() === EditStyleModel.timeAmPm)
		);
	}
}
